import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import get from 'lodash.get';
import {
    Grid,
    Typography,
    ExpansionPanel,
    ExpansionPanelDetails,
    ExpansionPanelSummary,
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';

import AddOnConfiguration from 'Console/components/applications/detail/settings/addOns/AddOnConfiguration';

const styles = (theme) => ({
    root: {
        margin: '42px 48px',
        [theme.breakpoints.between('xs', 'sm')]: {
            margin: '42px 48px',
            display: 'flex',
            flexDirection: 'column',
        },
    },
    formName: {
        width: '15%',
        marginRight: '3%',
        fontSize: theme.typography.pxToRem(14),
        [theme.breakpoints.between('xs', 'sm')]: {
            width: '100%',
            marginRight: 0,
        },
    },
    items: {
        paddingBottom: theme.typography.pxToRem(20),
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            marginRight: 0,
            paddingBottom: theme.typography.pxToRem(20),
        },
    },
    invitePanel: {
        boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.25)',
        marginTop: theme.typography.pxToRem(24),
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightMedium,
    },
    details: {
        backgroundColor: theme.palette.background.default,
        padding: '42px 48px',
        fontSize: theme.typography.pxToRem(14),
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.between('xs', 'sm')]: {
            margin: '42px 48px',
            display: 'flex',
            flexDirection: 'column',
        },
    },
    formInput: {
        width: '47%',
        [theme.breakpoints.between('xs', 'sm')]: {
            width: '100%',
            marginBottom: '5%',
        },
    },
});
// eslint-disable-next-line
class AddOnDetail extends Component {
    render() {
        const { classes, form, intl, addon } = this.props;

        let hasDefinitions = false;
        const definitions = get(addon, 'descriptor.definitions') || {};

        if (Object.getOwnPropertyNames(definitions).length > 0) {
            hasDefinitions = true;
        }

        return (
            <>
                <Grid className={classes.root}>
                    <Grid container direction="row" alignItems="center" className={classes.items}>
                        <Typography className={classes.formName} variant="body1">
                            {intl.formatMessage({ id: 'Settings.addOn.detail.vendor' })}
                        </Typography>

                        <Grid className={classes.formInput}>
                            <Typography className={classes.formName} variant="body1">
                                {get(addon, 'descriptor.vendor.url') ||
                                    get(addon, 'descriptor.vendor.name')}
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container direction="row" alignItems="center" className={classes.items}>
                        <Typography className={classes.formName} variant="body1">
                            {intl.formatMessage({ id: 'Settings.addOn.detail.systemKey' })}
                        </Typography>

                        <Grid className={classes.formInput}>
                            <Typography variant="body1">{get(addon, 'descriptor.systemKey')}</Typography>
                        </Grid>
                    </Grid>

                    <Grid container direction="row" alignItems="center" className={classes.items}>
                        <Typography className={classes.formName} variant="body1">
                            {intl.formatMessage({ id: 'Settings.addOn.detail.description' })}
                        </Typography>

                        <Grid className={classes.formInput}>
                            <Typography variant="body1">
                                {get(addon, 'descriptor.description')}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <ExpansionPanel>
                    <ExpansionPanelSummary className={classes.invitePanel} expandIcon={<ExpandMore />}>
                        <Typography className={classes.heading}>
                            {intl.formatMessage({
                                id: 'Settings.addOn.detail.expansionPanel.configuration',
                            })}
                        </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.details}>
                        <AddOnConfiguration addon={addon} form={form} />
                    </ExpansionPanelDetails>
                </ExpansionPanel>

                {hasDefinitions && (
                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            className={classes.invitePanel}
                            expandIcon={<ExpandMore />}
                        >
                            <Typography className={classes.heading}>
                                {intl.formatMessage({
                                    id:
                                        'Settings.addOn.detail.expansionPanel.addOnSpecificConfiguration',
                                })}
                            </Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.details}>
                            {/* <AddOnSpecificConfiguration definitions={definitions} /> */}
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                )}
            </>
        );
    }
}

export default injectIntl(withStyles(styles)(AddOnDetail));
